import * as badges from '@wix/auto_sdk_badges_badges';
import * as badgesV2 from '@wix/auto_sdk_badges_badges-v-2';

export { badges, badgesV2 };
